<template>
  <div>
    <div id="customer_request_accepted_modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="customerRequestAcceptedLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <loading-modal :is-loading="isLoading"></loading-modal>
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 480px;">
        <div class="modal-content text-center position-relative" style="background: #111; border: 1px solid rgba(255,255,255,0.1); border-radius: 24px; box-shadow: 0 20px 40px rgba(0,0,0,0.5);">
          
          <!-- Top-Right Close Button -->
          <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close" 
                  style="top: 16px; right: 20px; z-index: 10; opacity: 1; text-shadow: none; background: rgba(255,255,255,0.1); width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: none; cursor: pointer; transition: all 0.2s;">
            <i class="fa fa-times text-white font-size-14"></i>
          </button>

          <div class="modal-body pt-0 px-4 px-md-5 pb-4">
            <model-global-message
              :global-errors="globalErrors"
              :message="message"
              @clearMessages="clearMessages()"/>

            <!-- Header Badge & Title -->
            <div class="mb-4 mt-4 text-center">
              <div class="d-inline-flex align-items-center justify-content-center mb-3" style="width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, rgba(112,213,194,0.2) 0%, rgba(243,218,107,0.2) 100%); border: 1px solid rgba(112,213,194,0.35);">
                <i class="fa fa-check-circle font-size-28" style="background: linear-gradient(90deg, #70D5C2, #F3DA6B); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
              </div>
              <h4 class="text-white font-weight-700 mb-2 font-size-20">Request Accepted!</h4>
              <p class="text-muted font-size-14 mb-0">
                Please complete checkout and we will notify the creator to proceed with your custom request.
              </p>
            </div>

            <!-- Price Breakdown Card -->
            <div class="d-flex justify-content-between align-items-center p-3 mb-3 text-left" style="background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 16px;">
              <div class="d-flex align-items-center">
                <div class="me-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; border-radius: 12px; background: rgba(243,218,107,0.1); border: 1px solid rgba(243,218,107,0.2);">
                  <i class="fa fa-tag font-size-18" style="color: #F3DA6B;"></i>
                </div>
                <div>
                  <p class="text-muted font-size-12 mb-0" style="line-height: 1.2;">Total Amount</p>
                  <p class="text-white font-size-14 font-weight-600 mb-0">Accepted Offer</p>
                </div>
              </div>
              <div class="text-right">
                <span class="font-size-22 font-weight-700" style="color: #F3DA6B;">
                  ${{ customRequest.counterOfferPrice ? customRequest.counterOfferPrice : customRequest.offerPrice }}
                </span>
              </div>
            </div>

            <!-- Payment Selector -->
            <div class="dropdown w-100 text-left mb-4">
              <div class="d-flex align-items-center justify-content-between p-3 cursor-pointer" data-toggle="dropdown" aria-expanded="false" style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; transition: all 0.2s ease;">
                <div class="d-flex align-items-center">
                  <div class="me-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; border-radius: 12px; background: rgba(255,255,255,0.05);">
                    <i :class="['fa', selectedCard && selectedCard.cardId ? 'fa-credit-card' : 'fa-credit-card']" style="color: rgba(255,255,255,0.7); font-size: 18px;"></i>
                  </div>
                  <div>
                    <p class="text-muted font-size-12 mb-1" style="line-height: 1;">Paying from</p>
                    <p class="text-white font-size-14 font-weight-500 mb-0" style="line-height: 1;">
                      {{ selectedCard ? getCardDetails(selectedCard) : 'Pay with Stripe (Card / Apple Pay)' }}
                    </p>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center" style="width: 28px; height: 28px; background: rgba(255,255,255,0.1); border-radius: 50%;">
                  <i class="fa fa-chevron-down text-white font-size-10"></i>
                </div>
              </div>
              
              <div class="dropdown-menu w-100 mt-2 p-2 shadow-lg" style="background: #1e1e1e; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
                <a v-for="(card, index) in cards" :key="index"
                   href="#"
                   @click.prevent="cardSelected(index)"
                   class="dropdown-item d-flex align-items-center py-3 px-3 custom-dropdown-item" style="border-radius: 12px; margin-bottom: 4px; color: #fff; transition: background 0.2s;">
                  <div class="d-flex align-items-center justify-content-center me-3" style="width: 32px; height: 32px; border-radius: 8px; background: rgba(255,255,255,0.05);">
                    <i :class="['fa', card.cardId ? 'fa-credit-card' : (card.isAddCard ? 'fa-plus' : 'fa-globe')]" :style="{ color: card.isAddCard ? '#F3DA6B' : 'rgba(255,255,255,0.7)' }"></i>
                  </div>
                  <div class="d-flex flex-column text-left">
                    <span class="font-size-14 font-weight-500" :style="{ color: card.isAddCard ? '#F3DA6B' : '#fff' }">{{ getCardDetails(card) }}</span>
                    <span v-if="card.isAddCard" class="font-size-11 text-muted">Save card for 1-click checkout</span>
                  </div>
                  <i class="fa fa-chevron-right ms-auto text-muted font-size-12" v-if="card.isAddCard"></i>
                  <i class="fa fa-check ms-auto text-white" v-else-if="selectedCardIndex === index" style="background: #E9609B; border-radius: 50%; padding: 4px; font-size: 10px;"></i>
                </a>
              </div>
            </div>

            <!-- Dual Action Buttons (Side by Side) -->
            <div class="mt-2 d-flex align-items-center justify-content-between" style="gap: 12px;">
              <button type="button" class="cp-btn-ghost flex-fill py-2" data-dismiss="modal">
                Dismiss
              </button>
              <button type="button" class="cp-btn-primary flex-fill py-2" @click="pay()" :disabled="isPayBtnDisabled || isLoading">
                <i class="fa fa-spinner fa-spin me-1" v-if="isLoading"></i>
                <i class="fa fa-lock me-1" v-else></i>
                Pay Now
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <stripe-checkout
      v-if="showCheckOut"
      ref="checkoutRef"
      :pk="pk"
      :sessionId="sessionId"></stripe-checkout>

    <!-- In-Modal Add Card Dialog -->
    <model-add-card 
      ref="addCardModal" 
      id="custom_request_add_card_modal" 
      :is-loading="isAddingCard" 
      @save="saveNewCard"></model-add-card>
  </div>
</template>

<script>
import {customerCustomRequestMixin} from "@/mixin/customer-custom-request-mixin";
import {SERVICE_CONTENT, SERVICE_PAYMENT} from "@/properties/micro-service";
import {StripeCheckout} from "@vue-stripe/vue-stripe";
import ModelAddCard from "@/components/module/customer/shared/ModelAddCard";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ModelCustomerCustomRequestAccepted",
  mixins: [customerCustomRequestMixin],
  components: {
    StripeCheckout,
    ModelAddCard
  },
  data() {
    return {
      pk: "",
      sessionId: "",
      showCheckOut: false,
      isPayBtnDisabled: false,
      isAddingCard: false,
      cards: [],
      selectedCardIndex: 0,
      originalCardIndex: null,
    }
  },
  computed: {
    selectedCard() {
      if (this.cards && this.selectedCardIndex >= 0 && this.selectedCardIndex < this.cards.length) {
        return this.cards[this.selectedCardIndex];
      }
      return null;
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setPayInfluencer']),
    getCards() {
      let url = `${SERVICE_PAYMENT}/api/v1/stripe/customers/${this.getUser().id}/cards`;
      this.getData(url, (cards) => {
        let cardList = cards || [];
        let optionList = [];
        if (cardList.length > 0) {
          optionList.push(...cardList);
        }
        optionList.push({ brand: 'Add new card', isAddCard: true });
        optionList.push({ brand: 'Pay with Stripe (Card / Apple Pay)', isOnline: true });
        this.cards = optionList;
        this.setDefaultCardIndex(cardList);
      }, () => {
        this.cards = [
          { brand: 'Add new card', isAddCard: true },
          { brand: 'Pay with Stripe (Card / Apple Pay)', isOnline: true }
        ];
        this.selectedCardIndex = 1;
      });
    },
    setDefaultCardIndex(cardList) {
      if (cardList && cardList.length > 0) {
        let defaultIdx = this.cards.findIndex((card) => card.defaultCard === true && card.cardId);
        this.selectedCardIndex = defaultIdx !== -1 ? defaultIdx : 0;
      } else {
        // If no saved cards, default to "Pay with Stripe"
        let onlineIdx = this.cards.findIndex((card) => card.isOnline);
        this.selectedCardIndex = onlineIdx !== -1 ? onlineIdx : 0;
      }
      this.originalCardIndex = this.selectedCardIndex;
    },
    getCardDetails(card) {
      if (!card) return 'Pay with Stripe (Card / Apple Pay)';
      if (card.cardId) {
        return `${card.brand} .... ${card.last4Digit}`;
      } else {
        return card.brand || 'Pay with Stripe (Card / Apple Pay)';
      }
    },
    cardSelected(index) {
      let card = this.cards[index];
      if (card && card.isAddCard) {
        this.addNewCard();
      } else {
        this.selectedCardIndex = index;
      }
    },
    addNewCard() {
      this.$nextTick(() => {
        if (this.$refs.addCardModal) {
          this.$refs.addCardModal.show();
        }
      });
    },
    saveNewCard(newCard) {
      this.isAddingCard = true;
      let url = `${SERVICE_PAYMENT}/api/v1/stripe/customers/${this.getUser().id}/cards`;
      this.postData(url, newCard, (data) => {
        this.isAddingCard = false;
        let insertIdx = this.cards.findIndex(c => c.isAddCard);
        if (insertIdx !== -1) {
          this.cards.splice(insertIdx, 0, data);
          this.selectedCardIndex = insertIdx;
        } else {
          this.cards.unshift(data);
          this.selectedCardIndex = 0;
        }
        this.originalCardIndex = this.selectedCardIndex;
        if (this.$refs.addCardModal) {
          this.$refs.addCardModal.hide();
        }
      }, () => {
        this.isAddingCard = false;
      });
    },
    show(customRequest) {
      this.clearMessages();
      this.customRequest = customRequest;
      this.isPayBtnDisabled = false;

      let tr = customRequest && customRequest.transaction;
      let sessionId = (tr && tr.req && tr.req.id) || (tr && tr.res && tr.res.id);
      let pk = (tr && tr.othersData && tr.othersData.pk) || '';
      if (sessionId) {
        this.pk = pk;
        this.sessionId = sessionId;
        this.showCheckOut = true;
        this.setPayInfluencer(customRequest.influencer);
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.checkoutRef) {
              this.$refs.checkoutRef.redirectToCheckout();
            }
          });
        }, 100);
        return;
      }

      this.cards = [];
      this.getCards();
      $('#customer_request_accepted_modal').modal({ backdrop: 'static', keyboard: false });
    },
    hide() {
      $('#customer_request_accepted_modal').modal('hide');
    },
    pay() {
      this.isLoading = true;
      this.isPayBtnDisabled = true;
      let userId = this.getUser().id;
      let contentId = this.customRequest.content.id;
      this.setPayInfluencer(this.customRequest.influencer);

      let currentCard = this.cards[this.selectedCardIndex];
      let hasCard = currentCard && currentCard.cardId;
      let mode = hasCard ? 'Offline' : 'Online';

      let URL = `${SERVICE_CONTENT}/api/v1/customers/${userId}/content/${contentId}/purchase?mode=${mode}`;
      this.postData(URL, {}, (stripeCheckoutData) => {
        let otherData = (stripeCheckoutData && stripeCheckoutData.othersData) || {};
        let status = stripeCheckoutData ? stripeCheckoutData.status : null;
        this.pk = otherData.pk || '';
        this.sessionId = (stripeCheckoutData && stripeCheckoutData.req && stripeCheckoutData.req.id) || 
                         (stripeCheckoutData && stripeCheckoutData.res && stripeCheckoutData.res.id) || '';

        if (status === 'Success') {
          this.isLoading = false;
          this.isPayBtnDisabled = false;
          this.hide();
          this.$emit("savedCustomRequest", this.customRequest);
        } else if (status === 'InProgress' || mode === 'Online') {
          this.showCheckOut = true;
          setTimeout(() => {
            this.$nextTick(() => {
              if (this.$refs.checkoutRef) {
                this.$refs.checkoutRef.redirectToCheckout();
              }
            });
          }, 300);
        } else {
          this.isLoading = false;
          this.isPayBtnDisabled = false;
          this.pushGlobalError(status || 'Payment failed');
        }
      }, (err) => {
        this.isLoading = false;
        this.isPayBtnDisabled = false;
        // fallback to Online
        let onlineUrl = `${SERVICE_CONTENT}/api/v1/customers/${userId}/content/${contentId}/purchase?mode=Online`;
        this.postData(onlineUrl, {}, (stripeCheckoutData) => {
          let otherData = (stripeCheckoutData && stripeCheckoutData.othersData) || {};
          this.pk = otherData.pk || '';
          this.sessionId = (stripeCheckoutData && stripeCheckoutData.req && stripeCheckoutData.req.id) || 
                           (stripeCheckoutData && stripeCheckoutData.res && stripeCheckoutData.res.id) || '';
          this.showCheckOut = true;
          setTimeout(() => {
            this.$nextTick(() => {
              if (this.$refs.checkoutRef) {
                this.$refs.checkoutRef.redirectToCheckout();
              }
            });
          }, 300);
        });
      });
    },
  }
}
</script>

<style scoped>
.custom-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}
</style>


